import Document from '@components/Document/Document';
import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import { DocumentBlock } from '@features/api/response/tabContent/EDocuments';
import { useTheme } from '@mui/material';
import { DocumentListContainer } from './DocumentList.styles';

const DocumentList: React.FC<DocumentBlock> = ({ title, documents }) => {
  const theme = useTheme();
  return (
    <Flex flexDirection='column'>
      <Text
        variant='h6'
        fontWeight='fontWeightSemiBold'
        color={theme.palette.text.primary}
      >
        {title}
      </Text>
      <DocumentListContainer>
        {documents.map((document) => (
          <Document key={document.name} {...document} />
        ))}
      </DocumentListContainer>
    </Flex>
  );
};

export default DocumentList;
